import React from "react";
import { IonCol, IonRow, IonContent } from "@ionic/react";
import { IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/react";
import { EmptyChallengeList } from "../../models/EmptyChallenge";
import { Routes } from "../../routes";
import styles from "./ChallengeList.module.css";
import { ChallengeCard } from "./ChallengeCard";
import { useChallenges } from "./useChallenges";

interface ChallengeListProps {
  theme?: string;
}

export const ChallengeList: React.FC<ChallengeListProps> = ({ theme }) => {
  const {
    challenges,
    disableInfiniteScroll,
    isLoading,
    loadMore,
  } = useChallenges(theme);

  return (
    <IonContent className={styles.container}>
      <IonRow class="ion-justify-content-center">
        <IonCol class="ion-no-padding" size="12" sizeMd="9" sizeLg="6">
          {isLoading
            ? EmptyChallengeList.map((challenge, index) => (
                <ChallengeCard
                  key={index}
                  guid={challenge.Guid}
                  title={challenge.Title}
                  subtitle={challenge.Subtitle}
                  imageSrc={challenge.ImageSrc}
                  theme={challenge.Theme}
                />
              ))
            : challenges.map((challenge, index) => (
                <a
                  href={
                    "#" + Routes.HomePage + "/" + challenge.Guid
                  }
                  key={index}
                >
                  <ChallengeCard
                    key={index}
                    guid={challenge.Guid}
                    title={challenge.Title}
                    imageSrc={challenge.ImageSrc}
                    theme={challenge.Theme}
                    hideStartButton={true}
                  />
                </a>
              ))}
          <IonInfiniteScroll
            threshold="100px"
            disabled={disableInfiniteScroll}
            onIonInfinite={(e: CustomEvent<void>) => loadMore(e)}
          >
            <IonInfiniteScrollContent loadingText="Loading more challenges..."></IonInfiniteScrollContent>
          </IonInfiniteScroll>
        </IonCol>
      </IonRow>
      {/* <IonRow class="ion-justify-content-center">
        <IonCol class="ion-margin-bottom">
          <IonLabel color="medium">
            We're all out of ideas, help us by contributing yours!
          </IonLabel>
        </IonCol>
      </IonRow> */}
    </IonContent>
  );
};
